import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFoundPage: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="flex items-center justify-center h-full">
            <Result
                status="404"
                title="404"
                subTitle={t('notFound.subtitle', { defaultValue: '抱歉，您访问的页面不存在。' })}
                extra={
                    <Button type="primary" onClick={() => navigate('/', { replace: true })}>
                        {t('notFound.backHome', { defaultValue: '返回首页' })}
                    </Button>
                }
            />
        </div>
    );
};

export default NotFoundPage;
